<template>
  <div class="card card-plain" style="margin: 0 auto; max-width: 350px; background: #FFF;">
    <div class="pb-0 card-header text-start">
      <h4 class="font-weight-bolder">Termos</h4>
      <p class="mb-0">Para visualizar ou assinar seus termos, insira o CPF ou CNPJ do titular, abaixo:</p>
    </div>
    <div class="card-body">
      <div class="mb-3">
        <argon-input type="text" placeholder="CPF/CNPJ" name="document" size="lg" v-model="inputValue"
          v-model:validity="inputValidity" />
      </div>
      <div class="text-center">
        <argon-button :disabled="isLoading" class="mt-4" variant="gradient" color="warning" fullWidth size="lg"
          @click="checarTermos">
          {{ isLoading ? 'AGUARDE...' : 'CONTINUAR' }}
        </argon-button>
      </div>
    </div>
    <div class="px-1 pt-0 text-center card-footer px-lg-2">
      <p class="mx-auto mb-4 text-sm">
        Dúvidas?
        <a href="https://api.whatsapp.com/send?phone=553537311118" target="_blank"
          class="text-warning text-gradient font-weight-bold">Entre em contato pelo WhatsApp</a>
      </p>
    </div>
  </div>
</template>

<script>
const body = document.getElementsByTagName("body")[0];
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import api from "../services/api.js";

export default {
  name: "Inicio",
  components: {
    ArgonInput,
    ArgonButton,
  },
  data() {
    return {
      inputValue: "",
      inputValidity: "",
      isLoading: false,
    }
  },
  async created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
  methods: {
    async checarTermos() {
      if (!this.inputValidity || this.inputValidity === 'filling') {
        this.$swal({
          title: "Ops...",
          text: "É necessário preencher o CPF ou CNPJ do titular.",
        });
        return false;
      }

      if (this.inputValidity === 'invalid') {
        this.$swal({
          title: "Ops...",
          text: "O documento digitado é inválido.",
        });
        return false;
      }

      const cpfCnpj = this.inputValue

      this.isLoading = true;
      const totalTermos = await api.checarTermos(cpfCnpj);
      this.isLoading = false;

      if (!totalTermos && totalTermos !== 0) {
        this.$swal({
          title: 'Ops...',
          text: 'Houve um erro ao consultar os termos. Tente novamente mais tarde.'
        });
        return false;
      }

      if (totalTermos === 0) {
        this.$swal({
          title: "Ops...",
          text: "O titular ainda não possui termos."
        });
      }
      else {
        this.$router.push({ name: 'Verificacao' })
      }
    },
  }
};
</script>